var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsString, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { CustomFormElementLiteDto } from './custom-form-element.lite.dto.js';
import { CustomFormSectionResponseDto } from './custom-form-section.response.dto.js';
export class CustomFormFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    description;
    isDefaultForm;
    visibleForPatients;
    office;
    officeId;
    customFormElements;
    customFormSections;
    customFormAnswers;
    users;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormFullSizeDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormFullSizeDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormFullSizeDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormFullSizeDto.prototype, "isDefaultForm", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormFullSizeDto.prototype, "visibleForPatients", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Function)
], CustomFormFullSizeDto.prototype, "office", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormFullSizeDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => CustomFormElementLiteDto),
    __metadata("design:type", Array)
], CustomFormFullSizeDto.prototype, "customFormElements", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => CustomFormSectionResponseDto),
    __metadata("design:type", Array)
], CustomFormFullSizeDto.prototype, "customFormSections", void 0);
__decorate([
    Expose(),
    IsArray(),
    __metadata("design:type", Array)
], CustomFormFullSizeDto.prototype, "customFormAnswers", void 0);
__decorate([
    IsArray(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Array)
], CustomFormFullSizeDto.prototype, "users", void 0);
//# sourceMappingURL=custom-form.full-size.dto.js.map